import React from "react";
import { useEffectOnce } from "@lib-shared/hooks";
import { BusinessPage } from "core/constants";
import { useUpdatePage } from "core/hooks";
import { sessionManager } from "core/instances";
import { LocalStorageHelper } from "core/lib/local-storage-helper";
import Style from "core/lib/style";
import UrlUtils from "core/lib/url-utils";
import { Notice } from "./common-ui";

type SignUpProps = {
    returnUrl?: string | null;
    message?: string | null;
    email?: string | null;
}

const SignUp = (props: SignUpProps) => {
    const { returnUrl, message } = props;
    const [updateTitle, updateBodyCssName] = useUpdatePage();

    const pageTitle = "Sign Up";

    const root = UrlUtils.getRootPath();

    const defaultDirectUrl = `${root}${BusinessPage.dashboard.substring(1)}`;
    const defaultMessage = "Redirecting to sign up";

    LocalStorageHelper.clearLog();
    LocalStorageHelper.logout();

    useEffectOnce(() => {
        updateBodyCssName(Style.auth);
        updateTitle(pageTitle);

        sessionManager.signUp(returnUrl ?? defaultDirectUrl);
    });

    return (
        <Notice showSpinner={true}>
            <p dangerouslySetInnerHTML={{ __html: message ?? defaultMessage }} />
        </Notice>
    );
}

export default SignUp;
